import { useEffect } from 'react';
import NavBar from '@/components/NavBar';
import HeroSection from '@/components/personas/ta-leaders/HeroSection';
import IntegrationSection from '@/components/personas/ta-leaders/IntegrationSection';
import CTASection from '@/components/personas/ta-leaders/CTASection';
import SuccessStoriesSection from '@/components/personas/ta-leaders/SuccessStoriesSection';
import FAQSection from '@/components/personas/ta-leaders/FAQSection';
import MainFooter from '@/components/MainFooter';
import TripleAdvantage from '@/components/TripleAdvantage';
import SavitaTestimonial from '@/components/personas/ta-leaders/SavitaTestimonial';
import VariantTable from '@/components/VariantTable';

const ForTALeaders = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <NavBar />
      <main>
        <HeroSection />
        <SuccessStoriesSection />
        <TripleAdvantage />
        <SavitaTestimonial />
        <VariantTable />
        <IntegrationSection />
        <FAQSection />
        <CTASection />
      </main>
      <MainFooter />
    </div>
  );
};

export default ForTALeaders;
